module.exports = __webpack_public_path__ + "img/feather-customised/cancel.23c2689.svg";